import ReactDOM from 'react-dom';
import styles from './map.pcss';

const definePopupClass = (maps) => {

	let Popup;

	/**
	 * A customized popup on the map.
	 * @param {!google.maps.LatLng} position
	 * @param {!ReactElement} content
	 * @constructor
	 * @extends {google.maps.OverlayView}
	 */
	Popup = function(position, content) {
		this.position = position;
		if (!content) {
			return;
		}

		const pixelOffset = document.createElement('div');
		pixelOffset.classList.add(styles.popupBubbleAnchor);
		ReactDOM.render(content, pixelOffset);

		this.anchor = document.createElement('div');
		this.anchor.classList.add(styles.popupTipAnchor);
		this.anchor.appendChild(pixelOffset);

		maps.OverlayView.preventMapHitsFrom(this.anchor);

		// Optionally stop clicks, etc., from bubbling up to the map.
		this.stopEventPropagation();
	};

	/** Google.maps.OverlayView is only defined once the Maps API has loaded */
	Popup.prototype = Object.create(maps.OverlayView.prototype);

	/** Called when the popup is added to the map. */
	Popup.prototype.onAdd = function() {
		this.getPanes().floatPane.appendChild(this.anchor);
	};

	/** Called when the popup is removed from the map. */
	Popup.prototype.onRemove = function() {
		if (this.anchor.parentElement) {
			this.anchor.parentElement.removeChild(this.anchor);
		}
	};

	/** Called when the popup needs to draw itself. */
	Popup.prototype.draw = function() {
		const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
		// Hide the popup when it is far out of view.
		const display =
			Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
				'block' :
				'none';

		if (display === 'block') {
			this.anchor.style.left = `${divPosition.x}px`;
			this.anchor.style.top = `${divPosition.y}px`;
		}
		if (this.anchor.style.display !== display) {
			this.anchor.style.display = display;
		}
	};

	/** Stops clicks/drags from bubbling up to the map. */
	Popup.prototype.stopEventPropagation = function() {
		const anchor = this.anchor;
		anchor.style.cursor = 'auto';

		['dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart', 'pointerdown']
			.forEach((event) => {
				anchor.addEventListener(event, (e) => {
					e.stopPropagation();
				});
			});
	};

	return Popup;
};

export default definePopupClass;


// WEBPACK FOOTER //
// ./src/components/map-popup-factory.js